
import SubMenu from './SubMenu.vue'
import LeftMenu from './component/LeftMenu.vue'
import { mockMenu, mockParentMenu } from '../mock'
import Store, { modelMarketGuideList, ttsMarketGuideList, workBenchGuideList } from './store'
import Vuex from '@/store'
import { ElMenu } from 'element-plus'
import { ElMenuItem, ElSubmenu } from 'element-plus'
import { defineComponent, reactive, computed, inject, provide, ref, toRefs } from 'vue'
import router from '@/router'
import { setMenusAuth } from '@/Tool'
// import guideComponent from '@/pages/guide/guide.vue'
import api from '@/services'

export default defineComponent({
  components: {
    SubMenu,
    LeftMenu,
    ElMenu,
    ElMenuItem,
    ElSubmenu,
    // guideComponent,
  },
  setup() {
    let thedata = reactive({
      guideVisible: false,
      modelMarketGuideList,
      ttsMarketGuideList,
      workBenchGuideList,
      imgList: [],
    })
    const parentMenu = setMenusAuth(mockParentMenu, mockMenu).parentMenu
    const subMenu = setMenusAuth(mockParentMenu, mockMenu).subMenu
    const menuBg = 'linear-gradient(297deg, #BD96FF 0%, #635EFF 100%)'

    const menu_isCollapse = computed(() => Vuex.state.leftMenuCollapse)
    const is3Part = 'true' === sessionStorage.getItem('is3Part')
    const showLogo = !sessionStorage.getItem('isHuaweiyun')

    provide('leftMenu', parentMenu)
    const defaultActive = computed(() => Store.store.defaultActive)
    const parentDefaultActive = ref('1')

    Vuex.commit('set_data', {
      menus: parentMenu,
      subMenus: subMenu,
      selectSubmenus: subMenu[parentMenu[0].key] ? subMenu[parentMenu[0].key] : '',
    })

    let menu = computed(() => Vuex.state.selectSubmenus)
    let selectFirstMenu = computed(() => Vuex.state.selectMenu)
    const finalWidth = ref('204px')
    function onSetMenuCollapse() {
      Vuex.commit('set_data', {
        leftMenuCollapse: !menu_isCollapse.value,
      })
    }

    // 调取单个模块是否需要引导，判断依据是否首次进入
    const getGuidePages = async (val: string) => {
      let result = []
      try {
        result = await api.Scrm_sys_api.srcmLogin.getJudgeUserGuidePages({
          error: false,
          success: false,
          data: {
            menuCode: val,
          },
        })
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }

    // 添加个个模块内全屏预览
    const handlePicGuide = (type: string) => {
      switch (type) {
        // case 'home':
        //   getGuidePages(type).then((resp) => {
        //     const { success, data } = resp
        //     if (success && data) {
        //       thedata.imgList = thedata.modelMarketGuideList as []
        //       thedata.guideVisible = true
        //     }
        //   })
        //   break
        // case 'ttsMarket':
        //   getGuidePages(type).then((resp) => {
        //     const { success, data } = resp
        //     if (success && data) {
        //       thedata.imgList = thedata.ttsMarketGuideList as []
        //       thedata.guideVisible = true
        //     }
        //   })
        //   break
        // case 'workBench':
        //   getGuidePages(type).then((resp) => {
        //     const { success, data } = resp
        //     if (success && data) {
        //       thedata.imgList = thedata.workBenchGuideList as []
        //       thedata.guideVisible = true
        //     }
        //   })
        //   break
        // case 'home1':
        //   thedata.imgList = thedata.modelMarketGuideList as []
        //   thedata.guideVisible = true
        //   break
        // case 'ttsMarket1':
        //   thedata.imgList = thedata.ttsMarketGuideList as []
        //   thedata.guideVisible = true
        //   break
        // case 'workBench1':
        //   thedata.imgList = thedata.workBenchGuideList as []
        //   thedata.guideVisible = true
        //   break
        default:
          break
      }
    }

    const onParentSelect = (item: any): void => {
      if (!subMenu[item.key]) {
        // 对应的一级菜单么有二级菜单，直接打开一级菜单URL，并且如果展开的二级菜单收起来
        const tabsKeyArr = Vuex.state.tabsArr.map((item) => item?.name)
        if (!tabsKeyArr.includes(`${item.title}&${item.key}`)) {
          Vuex.state.tabsArr.push({
            key: item.key,
            name: `${item.title}&${item.key}`,
            url: item.url,
            parentKey: item.parentKey,
            child: item.child,
          })
          const newTabsArr = Vuex.state.tabsArr
          Vuex.commit('set_data', {
            tabsArr: newTabsArr,
          })
        }
        Vuex.commit('set_data', {
          selectSubmenus: [],
          leftMenuCollapse: true,
          selectMenu: item,
          activeTabName: `${item.title}&${item.key}`,
          currentMicroDom: item.url,
        })
        Vuex.state?.user?.info?.needGuidePage && handlePicGuide(item.key)
        router.push({
          path: item.url,
        })
        return
      }
      if (item.key === Vuex.state.selectMenu.key) {
        Vuex.state?.user?.info?.needGuidePage && handlePicGuide(item.key)
        Vuex.commit('set_data', {
          leftMenuCollapse: !Vuex.state.leftMenuCollapse,
          selectSubmenus: Vuex.state.subMenus[item.key],
        })
      } else {
        Vuex.state?.user?.info?.needGuidePage && handlePicGuide(item.key)
        Vuex.commit('set_data', {
          leftMenuCollapse: false,
          selectSubmenus: Vuex.state.subMenus[item.key],
          selectMenu: item,
        })
      }
    }
    //关闭引导回调
    const handleClose = () => {
      thedata.guideVisible = false
    }

    const handleCloseLeftNav = () => {
      Vuex.commit('set_data', {
        leftMenuCollapse: true,
      })
    }
    return {
      ...toRefs(thedata),
      finalWidth,
      menu,
      parentMenu,
      defaultActive,
      parentDefaultActive,
      menu_isCollapse,
      is3Part,
      showLogo,
      menuBg,
      handleClose,
      onParentSelect,
      handlePicGuide,
      handleCloseLeftNav,
    }
  },
})
